import { render } from "./LeaveBalance.vue?vue&type=template&id=350fb1ba&scoped=true"
import script from "./LeaveBalance.vue?vue&type=script&lang=js"
export * from "./LeaveBalance.vue?vue&type=script&lang=js"

import "./LeaveBalance.vue?vue&type=style&index=0&id=350fb1ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350fb1ba"]])

export default __exports__